export default __webpack_public_path__ + "static/media/gp.34687ce5.svg";